import { ICellRendererParams } from 'ag-grid-enterprise';
import BixToggle from '../bixToggle';

export interface IBixToggleCellRendererProps extends ICellRendererParams {
  checkedValue: string;
  idValue: string;
  getComponentId: (params: ICellRendererParams) => string;
  handleToggle: (user_Id: string, newCheckedState: boolean, params?: ICellRendererParams) => void;
  shouldHideToggle?: (params: ICellRendererParams) => boolean;
}

export default (props: IBixToggleCellRendererProps) => {
  const { checkedValue, idValue, getComponentId, handleToggle, shouldHideToggle } = props;

  const componentIdValue: string = getComponentId(props);

  let hide = false;
  if (shouldHideToggle) {
    hide = shouldHideToggle(props);
  }

  return hide ? null : (
    <BixToggle
      id={componentIdValue}
      checked={props.data[checkedValue]}
      onChange={(newCheckedState: boolean) => {
        handleToggle(props.data[idValue], newCheckedState, props);
      }}
    />
  );
};
